<!--
  提现
  lovi 2020-1-11
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('wallet.selectBankCard')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    >
      <span slot="right" @click="addBankCard">
        {{ $t("common.add") }}
      </span>
    </van-nav-bar>

    <div class="scroll-wrapper">
      <van-cell-group v-if="bankList.length">
        <van-cell
          class="bank-list"
          v-for="(item, index) in bankList"
          :key="index"
          :title="item.bank_name"
          :label="$t('wallet.lastFourDigits') + lastFour(item.card_number)"
          @click="chooseBank(index)"
        />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bankList: {
      //类型列表
      type: Array,
      default: function() {
        return [];
      }
    },
    curIndex: {
      //当前银行卡
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      this.$emit("update:chooseBankFlag", false);
    },
    addBankCard() {
      this.$emit("update:bindCardFlag", true);
    },
    chooseBank(index) {
      this.$emit("update:chooseBankFlag", false);
      this.$emit("update:curIndex", index);
    },
    lastFour(data) {
      // 保留银行卡后4位
      let newData = data.substring(data.length - 4);
      return newData;
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.bank-list {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  /deep/.van-cell__title {
    line-height: 1;
    span {
      font-size: 18px;
    }
    .van-cell__label {
      margin-top: 6px;
      font-size: 12px;
      line-height: 1;
    }
  }
}
</style>
